import { render, staticRenderFns } from "./youtube-player.vue?vue&type=template&id=2d1cdf3e"
import script from "./youtube-player.vue?vue&type=script&lang=js"
export * from "./youtube-player.vue?vue&type=script&lang=js"
import style0 from "./youtube-player.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports